import React, { useState } from "react";
import { connect } from "react-redux";
import { Box } from "@mui/material";
import { login } from "../../store/thunks";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import { InputError } from "../common/InputError";
import { useForm } from "react-hook-form";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";
import { post } from "../../api";
import { setLoginDataDetail } from "../../store/thunk/user";

const CreateAccount = ({ setStep, email, setLoginDataDetail }) => {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const {
    register,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm({});
  const goTo = (link) => {
    navigate(link);
  };
  // Watch the password field to validate against it
  const password = watch('password');
  const handleAccountSubmit = async (data) => {
    const { confirmPassword, ...payload } = data;
    setLoading(true);
    try{
      const url = `api/auth/register`;
      const res = await post(url, {...payload, email});
      if (res?.status === 200) {
        toast.success("Your email id is sucessfully registered.");
        setLoginDataDetail(res?.data)
        goTo('/dashboard');
      } else {
        toast.error("Something went wrong while register. Please try again.")
      }
      setLoading(false);
    } catch(e) {
      toast.error("Something went wrong while register. Please try again.")
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-md-12 right-panel bg-white">
        <form onSubmit={handleSubmit(handleAccountSubmit)}>
          <h2 className="mb-2">Welcome</h2>
          <p>
            <strong>Welcome!</strong><br/>
            <small>
              It looks like you don't have an account with us. We just need a
              few details from you and we can get you logged in.
            </small>
          </p>
          <hr />
          <div className="form-group mt-2 mb-2">
            <label for="firstName">First Name</label>
            <input
              type="text"
              className="form-control"
              id="firstName"
              placeholder="Your first name"
              {...register("firstName", {
                required: {
                  value: true,
                  message: `Please enter your first name.`,
                },
              })}
            />
            {errors?.firstName && (
              <InputError
                message={errors?.firstName?.message}
                key={errors?.firstName?.message}
              />
            )}
          </div>
          <div className="form-group mt-4 mb-2">
            <label for="lastName">Last Name</label>
            <input
              type="text"
              className="form-control"
              id="lastName"
              placeholder="Your last name"
              {...register("lastName", {
                required: {
                  value: true,
                  message: `Please enter your last name.`,
                },
              })}
            />
            {errors?.lastName && (
              <InputError
                message={errors?.lastName?.message}
                key={errors?.lastName?.message}
              />
            )}
          </div>
          <div className="form-group mt-4 mb-2">
            <label for="mobileNo">Mobile Number</label>
            <input
              type="text"
              className="form-control"
              id="mobileNo"
              placeholder="Your mobile number"
              {...register("mobileNo", {
                required: {
                  value: true,
                  message: `Please enter your mobile number.`,
                },
                pattern: {
                  value: /^[0-9]{11}$/, // Regular expression for 10 digits only
                  message: 'Mobile number must be exactly 11 digits.',
                },
              })}
            />
            {errors?.mobileNo && (
              <InputError
                message={errors?.mobileNo?.message}
                key={errors?.mobileNo?.message}
              />
            )}
          </div>
          <div className="form-group mt-4 mb-2">
            <label for="password">Password</label>
            <input
              type="password"
              className="form-control"
              id="password"
              placeholder="Your Password"
              {...register("password", {
                required: {
                  value: true,
                  message: `Please enter your password.`,
                },
                minLength: {
                  value: 8,
                  message: "Password must be at least 8 characters long.",
                },
              })}
            />
            {errors?.password && (
              <InputError
                message={errors?.password?.message}
                key={errors?.password?.message}
              />
            )}
          </div>
          <div className="form-group mt-4 mb-2">
            <label for="confirmPassword">Confirm Password</label>
            <input
              type="password"
              className="form-control"
              id="confirmPassword"
              placeholder="Confirm your password"
              {...register("confirmPassword", {
                required: {
                  value: true,
                  message: `Please confirm your password.`,
                },
                minLength: {
                  value: 8,
                  message: "Confirm password must be at least 8 characters long.",
                },
                validate: (value) =>
                  value === password || 'Passwords do not match.',
              })}
            />
            {errors?.confirmPassword && (
              <InputError
                message={errors?.confirmPassword?.message}
                key={errors?.confirmPassword?.message}
              />
            )}
          </div>
          {isLoading && (
            <Box sx={{ display: "flex" }}>
              <CircularProgress />
            </Box>
          )}
          {!isLoading && (
            <div className="form-group mt-4">
              <button
                type="submit"
                className="btn btn-primary rounded w-100 login-submit"
              >
                Create Account and Get Started
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default connect(null, { login, setLoginDataDetail })(CreateAccount);
